// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as SuspensionReasonApiModel from "../api-model/SuspensionReasonApiModel.bs.js";

function decodeSuspensionDuration(duration_info) {
  return List.map((function (duration) {
                return {
                        hours: duration.hours,
                        tag: duration.tag
                      };
              }), duration_info);
}

function execute(json) {
  var model = DeccoUtils$Catalyst.resolveResult(SuspensionReasonApiModel.t_decode(json), "SuspensionReasonEntityMapper.re");
  return List.map((function (suspension) {
                return {
                        id: suspension.id,
                        description: suspension.description,
                        suspension_durations: decodeSuspensionDuration(suspension.suspension_durations)
                      };
              }), model.result);
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
